import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Loader from 'components/Loader/Loader';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type DeleteUserConfirmationDialogProps = {
  opened: boolean;
  close: () => void;
  deleteUser: () => void;
  deleteInProgress: boolean;
  errors?: string[];
};

const DeleteUserConfirmationDialog: FC<DeleteUserConfirmationDialogProps> = ({ opened, deleteInProgress, close, deleteUser, errors }) => {
  const { t } = useTranslation();

  const [confirmationTitle, setConfirmationTitle] = useState<string>(t('pages.settings.profile.delete.confirm.title'));

  useEffect(() => {
    if (errors?.length > 0) {
      setConfirmationTitle(t('pages.settings.profile.delete.error.title'));

      return;
    }

    setConfirmationTitle(t('pages.settings.profile.delete.confirm.title'));
  }, [errors]);

  return (
    <Dialog className="delete-user-confirmation-dialog" open={opened} onClose={close}>
      <DialogTitle>{confirmationTitle}</DialogTitle>
      <DialogContent className="delete-user-confirmation-dialog__content">
        <div className="delete-user-confirmation-dialog__content-wrapper mobile-full-width">
          {deleteInProgress && <Loader />}

          {!deleteInProgress && errors?.length === 0 && (
            <>
              <p>{t('pages.settings.profile.delete.confirm.notice')}</p>
              <p>
                <b>{t('pages.settings.profile.delete.confirm.confirmation-logging-out')}</b>
              </p>
            </>
          )}

          {!deleteInProgress && errors?.length > 0 && (
            <div className="delete-user-confirmation-dialog__errors-wrapper">
              <p>{t('pages.settings.profile.delete.error.noticed-errors-title')}:</p>
              <ul>
                {errors.map((error) => (
                  <li key={error}>{error}</li>
                ))}
              </ul>
              <p>{t('pages.settings.profile.delete.error.solution')}</p>
            </div>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        {errors?.length === 0 && (
          <Button variant="contained" onClick={deleteUser} color="primary" disabled={deleteInProgress}>
            {t('pages.settings.profile.delete.confirm.confirm-deletion')}
          </Button>
        )}

        <Button variant="outlined" onClick={close} color="primary" disabled={deleteInProgress}>
          {t('pages.settings.profile.delete.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteUserConfirmationDialog;
